import { ForceGraphInputType, NodeType, LinkType, categories } from './types'

export const getNodeLabel = (node: NodeType) => {
  if (node.entityType === 'persona_natural') {
    return (
      node.data?.nombre_completo?.transunion_unholster ??
      Object.values(node.data?.nombre_completo || {}).find((value) => value !== undefined)
    )
  }
  if (node.entityType === 'persona_juridica') {
    return (
      node.data?.razon_social?.sii ??
      Object.values(node.data?.razon_social || {}).find((value) => value !== undefined)
    )
  }
  if (node.entityType === 'actividad_economica') {
    return (
      node.data?.descripcion_actividad?.sii ??
      Object.values(node.data?.descripcion_actividad || {}).find((value) => value !== undefined)
    )
  }
  if (node.entityType === 'causa') {
    return (
      node.data?.caratulado?.poderjudicial ??
      Object.values(node.data?.caratulado || {}).find((value) => value !== undefined)
    )
  }
  if (node.entityType === 'direccion') {
    return (
      node.data?.comuna?.sii ??
      Object.values(node.data?.comuna || {}).find((value) => value !== undefined)
    )
  }
  if (node.entityType === 'pais') {
    return (
      node.data?.nombre_pais?.fatf_gafi ??
      Object.values(node.data?.nombre_pais || {}).find((value) => value !== undefined)
    )
  }
  if (node.entityType === 'vehiculo') {
    return (
      node.data?.ppu?.transunion_unholster ??
      Object.values(node.data?.ppu || {}).find((value) => value !== undefined)
    )
  }

  return node.entityType
}

const getRelationshipLabel = (edge: LinkType) => {
  const tipo_parentesco = edge.data?.tipo_parentesco ?? {}
  // Get the first value that is not null in tipo_parentesco.
  const relative_relationship = Object.values(tipo_parentesco).find((value) => value !== null)
  // If the relationship is a relative relationship, use it as the label
  if (relative_relationship) {
    return relative_relationship
  }
  if (edge.entityType.includes('es_socio')) {
    return 'socio'
  }
  return edge.entityType
}

const createForceGraphData = (nodes: NodeType[], edges: LinkType[]) => {
  const forceGraphData: ForceGraphInputType = {
    nodes: nodes.map((node) => ({
      id: node.id,
      label: getNodeLabel(node),
      val: 15,
      category: node.entityType,
      feeds: node.feeds,
      isMain: node.id === 'main',
      color: categories[node.entityType].color,
      secondColor: categories[node.entityType].secondColor,
      fontColor: categories[node.entityType].fontColor,
      data: node.data,
    })),
    links: edges.map((edge) => ({
      source: edge.source,
      target: edge.target,
      label: getRelationshipLabel(edge),
      id: edge.id,
      feeds: edge.feeds,
    })),
  }

  forceGraphData.links.forEach((link) => {
    const a = forceGraphData.nodes.find((n) => n.id === link.source)
    const b = forceGraphData.nodes.find((n) => n.id === link.target)
    if (a) {
      !a.neighbors && (a.neighbors = [])
      a.neighbors.push(b)
      !a.links && (a.links = [])
      a.links.push(link)
    }
    if (b) {
      !b.neighbors && (b.neighbors = [])
      b.neighbors.push(a)
      !b.links && (b.links = [])
      b.links.push(link)
    }
  })

  return forceGraphData
}

export default createForceGraphData
